'use strict';

exports.NOT_STARTED_YET = 'The libp2p node is not started yet';